<div class="data_opzioni opzioni-dir" appDropdownFocus *ngIf="item.section?.isMain">
  <a style="color: #555;" aria-expanded="false" aria-haspopup="true" class="dropdown-toggle" data-toggle="dropdown" href="#" role="button">Opzioni
    <span class="glyphicon glyphicon-option-vertical"></span>
  </a>
  <div class="dropdown-menu menu-file-dir">
    <ul>
      <!--<li>
        <span class="glyphicon glyphicon-open-file"></span>
        <a href="javascript:void(0);">Aggiungi documento</a>
      </li>-->
      <li *ngIf="item.section?.writable && item.section.isMain" [ngStyle]="{'margin-bottom': isTable ? '12px' : '0'}">
        <span class="glyphicon glyphicon-edit"></span>
        <a href="javascript:void(0)" (click)="openUpdateMetadatiModal(item.documento)">Rinomina cartella</a>
      </li>
      <li *ngIf="!item.section?.writable && item.section.isMain" class="disabilitata" [ngStyle]="{'margin-bottom': isTable ? '12px' : '0'}">
        <span class="glyphicon glyphicon-edit"></span>
        Rinomina cartella
      </li>
      <li *ngIf="item.section?.writable && item.section?.isMain">
        <span class="glyphicon glyphicon-trash"></span>
        <a href="javascript:void(0);" (click)="openDeleteDirModal(item.documento)">Elimina cartella</a>
      </li>
      <li *ngIf="!item.section?.writable && item.section?.isMain" class="disabilitata">
        <span class="glyphicon glyphicon-trash"></span>
        Elimina cartella
      </li>
    </ul>
  </div>
</div>
